/**
 * Context Service
 * Fetches the aggregated startup context for the authenticated user
 * (identity + workspaces + settings) in a single request.
 */
import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';
import type { GetUserContextResponse } from '@/types/api/responses';

export const contextService = {
  /**
   * Get the aggregated user context used to bootstrap the application.
   */
  getUserContext: () =>
    apiClient.get<GetUserContextResponse>(API_ENDPOINTS.USERS.CONTEXT),
};
